module.exports = __webpack_public_path__ + "img/vespa_260.02bcc95a.png";